import DatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import 'react-datepicker/dist/react-datepicker.css';
import './DateInput.css';

registerLocale('fr', fr);

/**
 * Remplacement universel pour <input type="date" />
 *
 * Props :
 *   value       — string YYYY-MM-DD (ou vide)
 *   onChange    — (stringYYYY-MM-DD) => void
 *   placeholder — texte affiche si vide
 *   className   — classes CSS supplementaires
 *   isClearable — affiche le bouton x (defaut false)
 *   minDate     — Date object ou string YYYY-MM-DD
 *   maxDate     — Date object ou string YYYY-MM-DD
 *   required    — passe a l'input natif (pas gere par react-datepicker)
 */
export default function DateInput({
  value,
  onChange,
  placeholder = 'Choisir une date',
  className = '',
  isClearable = false,
  minDate,
  maxDate,
  ...rest
}) {
  const toDate = (v) => {
    if (!v) return null;
    if (v instanceof Date) return v;
    const d = new Date(v + 'T00:00:00');
    return isNaN(d.getTime()) ? null : d;
  };

  const toStr = (d) => {
    if (!d) return '';
    const y   = d.getFullYear();
    const m   = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  return (
    <DatePicker
      selected={toDate(value)}
      onChange={(d) => onChange(toStr(d))}
      dateFormat="dd MMMM yyyy"
      locale="fr"
      placeholderText={placeholder}
      className={`datepicker-input${className ? ' ' + className : ''}`}
      calendarClassName="datepicker-calendar"
      isClearable={isClearable}
      minDate={toDate(minDate)}
      maxDate={toDate(maxDate)}
      {...rest}
    />
  );
}
